import {useEffect, useState} from "react";
import loadable from "@loadable/component";
import {useTranslation} from "@i18n";
import { Link } from "react-router-dom";
import { CDN_LINK } from "@globalConfig";
import stl from "./PaymentTabBox.module.css";
import { cashCheckout1Event } from "@/utils/dataLayerEvents";
import { trackEvents } from "@/common/events/events";
import ProgressiveImage from "@componentsShared/ProgressiveImage";
import {BottomSheet} from "@componentsShared/BottomSheet";
import InstallmentCalculatorView from "@/_MiniApps/Installment-calculator/InstallmentCalculatorView";
import useBoolean from "@hooks/useBoolean";
import InstallmentCalculatorTerms from "@/_MiniApps/Installment-calculator/InstallmentCalculatorTerms";
import useHelpers from "@hooks/useHelpers";

const fallback = {
  fallback: null,
};

const PaymentTabBoxPopup = loadable(
    () => import("./PaymentTabBoxPopup"),
    fallback
);

const CallUsBy = loadable(
    () => import("./CallUsBy"),
    fallback
);

const PaymentTabBox = ({
  priceSection,
  postId,
  postTitle,
  reserved,
  g4_data,
  footer_section,
  isUsed,
  car_condition
}) => {
  const { t } = useTranslation(["web_post_view", "web_common"]);
  const [showNumbers, setShowNumbers] = useState(false);
  const [showPaymentTabBoxPopup, setShowPaymentTabBoxPopup] = useState(false);
    const { value: isCalculatorOpen, setTrue: openCalculator, setFalse: closeCalculator } = useBoolean();
    const [hasInteracted, setHasInteracted] = useState(false);
    const {createUrl} = useHelpers();

    const handleFirstInteraction = ({field}) => {
        if (hasInteracted) {
            console.log('field', field)
            setHasInteracted(false);
            trackEvents("finance_calculator_interact", {
                ...g4_data,
                post_trim: g4_data?.post_ext,
                field_interaction: field
            });
        }
    };

    useEffect(() => {
        if (isCalculatorOpen) {
            setHasInteracted(true);
        } else {
            setHasInteracted(false);
        }
    }, [isCalculatorOpen]);

    const handleCalculatorClick = () => {
        openCalculator();
        trackEvents("finance_calculator_open", {
            ...g4_data,
            post_trim: g4_data?.post_ext,
        })
    }
  return (
      <>
        <div className={stl.newContainer}>
        <div className={stl.newPriceFlx}>
          <div>
            <div className={stl.newCahsPay}>
              <strong className={stl.NewPriceTitle}>
                {t("سعر الكاش", { ns: "web_post_view" })}
              </strong>
              <strong className={stl.NewPriceHolder}>
                {priceSection?.vat_price?.text}
                <span>{priceSection?.currency}</span>
              </strong>
              {priceSection?.old_price?.text_with_vat && (
                <div className={stl.NewOldPriceHolder}>
                  <strong>
                    {priceSection?.old_price?.text_with_vat}
                    {priceSection.old_price?.text_with_vat && (
                      <span> {priceSection?.currency}</span>
                    )}
                  </strong>
                </div>
              )}
              <p className={stl.newCashNote}>
                <img
                  width="14px"
                  height={"14px"}
                  src={CDN_LINK + "/assets/images/GreyCheck.svg"}
                  alt="tik"
                />
                <span>
                  {t("السعر يشمل الضريبة المضافة", {
                    ns: "web_post_view",
                  })}
                </span>
              </p>
            </div>
          </div>
          {priceSection?.finance_price?.text && (
            <div>
              <div
                className={stl.newKastContainer}
                onClick={() => handleCalculatorClick()}>
                <strong className={stl.NKTitle}>
                  {t("يبدأ القسط من", {
                    ns: "web_post_view",
                  })}
                </strong>
                <strong className={stl.NKPrice}>
                  {priceSection?.finance_price?.text}
                  <span>
                    {t("ريال/شهرياً", {
                      ns: "web_post_view",
                    })}
                  </span>
                </strong>
                <strong className={stl.NewOpenKastDetails}>
                    <ProgressiveImage
                        width={16}
                        height={16}
                        waitUntilInteractive
                        src={CDN_LINK + "/assets/images/arithmetic.svg"}
                        alt="arrow"
                    />
                  <span className={stl.underline}>
                    {t("احسب التمويل", {
                      ns: "web_post_view",
                    })}
                  </span>

                </strong>
              </div>
            </div>
          )}
          {priceSection?.finance_price?.text && showPaymentTabBoxPopup &&  (
           <PaymentTabBoxPopup priceSection={priceSection} onClose={()=>setShowPaymentTabBoxPopup(false)} isUsed={isUsed}/>
          )}
        </div>
        {reserved == 1 ? (
          <div className={stl.reservedCarBox}>
            <strong>{t("هذه السيارة محجوزة", { ns: "web_post_view" })}</strong>
            {!showNumbers && (
              <span
                className={["greenTextBtn", "m-hide"].join(" ")}
                onClick={() => {
                  setShowNumbers(true);
                }}>
                {t("تواصل مع مندوب المبيعات", { ns: "web_post_view" })}
              </span>
            )}
          </div>
        ) : (
          <>
            <Link
              to={createUrl(`/pre-checkout/${postId}`)}
              id="BuyNow"
              className={["greenBtn", stl.buyLinkPPt, "m-hide"].join(" ")}
              onClick={() => {
                cashCheckout1Event("checkout_lead", g4_data);
                  sessionStorage.removeItem(`installment-calculator-${postId}`)
                  trackEvents("book_car", {
                  ...g4_data,
                  post_trim: g4_data?.post_ext,
                      inventory_type_string: g4_data?.inventory_type_string,
                });
              }}>
              {t("المتابعة", {
                ns: "web_post_view",
              })}
            </Link>
            {!showNumbers && (
              <span
                onClick={() => {
                  setShowNumbers(true);
                }}
                className={["greenTextBtn", stl.buyLinkPPt, "m-hide"].join(
                  " "
                )}>
                {t("اتصل بنا للحجز", { ns: "web_post_view" })}
              </span>
            )}
          </>
        )}

        {showNumbers && <CallUsBy postId={postId} footer_section={footer_section} postTitle={postTitle} onClose={()=>setShowNumbers(false)}/>}
      </div>
          <BottomSheet
              open={isCalculatorOpen}
              onOpen={openCalculator}
              onClose={closeCalculator}
              screens={[
                  {
                      title: t('احسب قيمة التمويل', {ns: 'web_post_view'}),
                      component: <InstallmentCalculatorView
                          carCondition={car_condition}
                          cashPrice={priceSection?.vat_price.text.replace(/,/g, "")}
                          onClose={closeCalculator}
                          onInteraction={handleFirstInteraction}
                      />
                  },
                  {
                      title: t('شروط التمويل', {ns: "web_post_view"}),
                      component: <InstallmentCalculatorTerms />
                  }
              ]}
          />
      </>
  );
};

export default PaymentTabBox;
